export const buildCaptureAdvancedPassengerInformationVariables = ({ booking, passenger, data }) => ({
  bookingReference: booking.reference,
  passengerUUID: passenger.uuid,
  ...(passenger.isInfant ? { guardianUUID: passenger.guardianUUID } : { passengerID: passenger.id }),
  ...data
});
